import { Delete } from '@mui/icons-material'
import { IconButton } from '@mui/material'

interface DeleteActionButtonProps {
  onClick: () => void
}

const DeleteActionButton = ({ onClick }: DeleteActionButtonProps) => {
  return (
    <IconButton color={'error'} aria-label="Delete" onClick={onClick}>
      <Delete />
    </IconButton>
  )
}

export default DeleteActionButton
